<template>
  <div>
    <all-productslist v-if="isContentLoaded" :allProductslist="Products"/>
    <footer-menu/>
  </div>
</template>
<script>
import allProductslist from "@/components/allProductslist";

import FooterMenu from "@/components/footer";

export default {
  name: "search-page",
  metaInfo: {
    title: 'جستجو'
  },
  components: {FooterMenu, allProductslist},

  data: () => ({
    Products: [],
    isContentLoaded: false
  }),
  mounted() {
    this.getData()
  },
  methods: {
    listenerChild(reply) {
      this.$route.query.KeyWord = reply;
      this.getData()
      console.log("reply")
      console.log(reply)
    },

    getData() {
      this.Products = [];
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/SearchProduct?keyword=" + this.$route.query.KeyWord, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.Products = json
            this.isContentLoaded = true
            console.log(json)
          })
          .catch(error => console.log('error', error));
    }
  },
  watch: {
    '$route.query.KeyWord'() {
      console.log(this)
      this.getData()
    }
  }


}
</script>

<style scoped>

</style>